import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from 'datatables.net';
import { Subject } from 'rxjs';
import { ReportScheduleService } from 'src/app/services/report-schedule.service';
import { ReportService } from 'src/app/services/report.service';
import { SocketService } from 'src/app/services/socket.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-reports-schedule',
  templateUrl: './reports-schedule.component.html',
  styleUrls: ['./reports-schedule.component.css'],
})
export class ReportsScheduleComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private service: ReportScheduleService
  ) {}

  role: string;

  // configs
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
  };
  dtTrigger: Subject<any> = new Subject<any>();

  reportTypes: any[] = [];
  data: any[] = [];

  selectedReportType: number;
  isActive = true;
  time: Date = new Date();
  day: string = '';

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Reports Schedule');
    },100)
    this.role = sessionStorage.getItem('role');
    this.getReportTypes();
  }

  edit(item) {
    this.selectedReportType = item.id;
    const detail = this.data.find((el) => el.reportTypeId === item.id);
    if (detail) {
      this.isActive = detail.isActive === 1 ? true : false;

      if (detail.cronExpression) {
        const parts = detail.cronExpression.split(' ');

        this.time = new Date();
        const minutes = parts[0];
        const hours = parts[1];
        this.time.setHours(hours);
        this.time.setMinutes(minutes);
        this.day = parts[2];
      }
    } else {
      this.isActive = true;
      this.time = new Date();
      this.day = '';
    }
    $('#edit-modal').modal('show');
  }

  submit() {
    let hours = this.time.getHours();
    let minutes = this.time.getMinutes();

    let cronExpression = `${minutes} ${hours} ${this.day} * *`;
    const data = {
      reportTypeId: this.selectedReportType,
      cronExpression: cronExpression,
      isActive: this.isActive ? 1 : 0,
    };
    console.log(data);

    this.service.save(data).subscribe({
      next: (res: any) => {
        this.getReportTypes();
        $('#edit-modal').modal('hide');
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  reset() {}

  closePopup() {}

  getList() {
    this.service.list().subscribe({
      next: (res: any) => {
        this.data = res;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getReportTypes() {
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(`${environment.reportApiUrl}/report/report-types`, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe({
        next: (res: any) => {
          this.getList();
          this.reportTypes = res;
          this.dtTrigger.next(null);
          $('#DataTables_Table_1').dataTable().fnDestroy();
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  getActive(id) {
    const item = this.data.find((el) => el.reportTypeId === id);
    if (item) {
      return item.isActive === 1 ? 'Yes' : 'No';
    }

    return 'Not configured';
  }

  getCronExpression(id) {
    const item = this.data.find((el) => el.reportTypeId === id);
    if (item && item.cronExpression) {
      const parts = item.cronExpression.split(' ');

      const minutes = parts[0];
      const hours = parts[1];
      const dayOfMonth = parts[2];

      let humanReadable = `Every ${dayOfMonth}th day of the month at ${hours.padStart(
        2,
        '0'
      )}:${minutes.padStart(2, '0')}`;

      return humanReadable;
    }

    return 'Not configured';
  }

  days: string[] = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
  ];
}
